import { useTranslations } from '@vocab/react';
import { Text, TextLink } from 'braid-design-system';

import translations from '../../locales.vocab';

const DefaultError = () => {
  const { t } = useTranslations(translations);

  return (
    <>
      {t('order.error.payment.error', {
        Title: (children) => (
          <>
            <Text weight="strong">{children}</Text>
            <br />
          </>
        ),
        Content: (children) => <Text>{children}</Text>,
        Link: (children) => (
          <TextLink href="/contactus" target="_blank">
            {children}
          </TextLink>
        ),
      })}
    </>
  );
};

export default DefaultError;
